import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { Label } from "../ui/label";
const PropertyInfoForm = ({ formData, handleFormChange, validationErrors }) => {
  const inputClassName =
    "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-[#239D80] focus:border-[#239D80] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#239D80] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";
  const selectClassName =
    "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base text-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";
  return (
    <div className="p-6 py-0">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Tell us about the property</h2>
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="squareFeet" className="block text-sm font-medium text-gray-700 mb-1">
              Square Feet
            </label>
            <input
              id="squareFeet"
              type="number"
              min="0"
              max="999999"
              value={formData.squareFeet}
              onChange={(e) => handleFormChange("squareFeet", e.target.value)}
              className={`${inputClassName} show-spinner`}
              placeholder="e.g., 2000"
            />
            
          </div>
          <div>
            <label htmlFor="yearBuilt" className="block text-sm font-medium text-gray-700 mb-1">
              Year Built
            </label>
            <input
              id="yearBuilt"
              type="number"
              min="1800"
              max={new Date().getFullYear()}
              value={formData.yearBuilt}
              onChange={(e) => handleFormChange("yearBuilt", e.target.value)}
              className={`${inputClassName} show-spinner`}
              placeholder="e.g., 1995"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label htmlFor="bedrooms" className="block text-sm font-medium text-gray-700 mb-1">
              # of Bedrooms
            </label>
            <select
              id="bedrooms"
              value={formData.bedrooms}
              onChange={(e) => handleFormChange("bedrooms", e.target.value)}
              className={selectClassName}
            >
              <option value="">Select</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6+">6+</option>
            </select>
          </div>
          <div>
            <label htmlFor="bathrooms" className="block text-sm font-medium text-gray-700 mb-1">
              # of Bathrooms
            </label>
            <select
              id="bathrooms"
              value={formData.bathrooms}
              onChange={(e) => handleFormChange("bathrooms", e.target.value)}
              className={selectClassName}
            >
              <option value="">Select</option>
              <option value="1">1</option>
              <option value="1.5">1.5</option>
              <option value="2">2</option>
              <option value="2.5">2.5</option>
              <option value="3">3</option>
              <option value="3.5">3.5</option>
              <option value="4+">4+</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Garage</label>
            <RadioGroup
              value={formData.hasGarage === null ? "" : formData.hasGarage ? "yes" : "no"}
              onValueChange={(value) => handleFormChange("hasGarage", value === "yes")}
              className="flex gap-6 h-10 items-center"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="yes" id="garage-yes" />
                <Label htmlFor="garage-yes" className="cursor-pointer">Yes</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="no" id="garage-no" />
                <Label htmlFor="garage-no" className="cursor-pointer">No</Label>
              </div>
            </RadioGroup>
          </div>
        </div>
        <div>
          <label htmlFor="gateCode" className="block text-sm font-medium text-gray-700 mb-1">
            Gate Code
          </label>
          <input
            id="gateCode"
            value={formData.gateCode || ""}
            onChange={(e) => handleFormChange("gateCode", e.target.value)}
            className={inputClassName}
            placeholder="e.g., #1234 or Call box"
          />
        </div>
        <div>
          <label htmlFor="propertyNotes" className="block text-sm font-medium text-gray-700 mb-1">
            Special Instructions or Property Details
          </label>
          <textarea
            id="propertyNotes"
            value={formData.propertyNotes || ""}
            onChange={(e) => handleFormChange("propertyNotes", e.target.value)}
            placeholder="e.g., Park on the street, dog in backyard, key under mat, access through back gate..."
            className="flex min-h-[100px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground hover:border-[#239D80] focus:border-[#239D80] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#239D80] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm my-[10px] resize-y"
          />
        </div>
      </div>
    </div>
  );
};
export default PropertyInfoForm;
